import { render } from "./TestProxy.vue?vue&type=template&id=37a3a232&scoped=true"
import script from "./TestProxy.vue?vue&type=script&lang=js"
export * from "./TestProxy.vue?vue&type=script&lang=js"

import "./TestProxy.vue?vue&type=style&index=0&id=37a3a232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a3a232"]])

export default __exports__